import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface IReclamationsService {
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  tipoAcao?: number;
  consultCode?: number;
  codOperadora?: number;
  reqBody?: ReqBodyType;
  data1?: string;
  data2?: string;
  mes?: string;
  ano?: string;
  codEmpresa?: string;
}

class ReclamationsService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listReclamations = async ({
    codUsu,
    perfilUsu,
    token,
  }: IReclamationsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Reclamacoes?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoPesquisa=0&consulta=0`,
    });
  };

  listConsultsWithSomeReclamationAtPeriod = async ({
    codUsu,
    perfilUsu,
    codEmpresa,
    mes,
    ano,
    token,
  }: IReclamationsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Contestacao?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&mes=${mes}&ano=${ano}`,
    });
  };

  getAnswerStatusTypesOptions = async ({
    codUsu,
    perfilUsu,
    token,
  }: IReclamationsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Reclamacoes?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoPesquisa=1&consulta=0`,
    });
  };

  getReclamationDetails = async ({
    codUsu,
    perfilUsu,
    consultCode,
    token,
  }: IReclamationsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Reclamacoes?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoPesquisa=1&consulta=${consultCode}`,
    });
  };

  answerReclamation = async ({
    reqBody,
    token
  }: IReclamationsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_Reclamacoes',
      reqBody,
    });
  };

  addReclamation = async ({
    reqBody,
    token
  }: IReclamationsService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_Contestacao',
      reqBody,
    });
  };

  downloadReport = async ({
    data1,
    data2,
    codUsu,
    perfilUsu,
    token,
  }: IReclamationsService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Rels?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=0&data1=${encodeURIComponent(data1 ?? 0)}&data2=${encodeURIComponent(data2 ?? 0)}&tipoRel=57&valorInt=0&valorInt1=0&valorInt2=0&valorLong=0&valorLong1=0&valorLong2=0&valorString=0&valorString1=0&valorString2=0`,
    });
  };
}

export default new ReclamationsService();
